// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

import { createIllustration } from '@atlassian/jira-illustration/src/ui/index.tsx';
import type {
	AsImgProps,
	IllustrationFn,
	SVGViewBox,
} from '@atlassian/jira-illustration/src/ui/types.tsx';
// eslint-disable-next-line jira/import/no-duplicates, import/no-duplicates
import srcDark from '../../assets/infrastructure-crane.svg';
// eslint-disable-next-line import/no-duplicates
import srcLight from '../../assets/infrastructure-crane.svg';

const Illustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
});

export default Illustration;

// for advanced use only
export const viewBox: SVGViewBox = [0, 0, 276, 276];
